var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var a = (o, e, r) => e in o ? f(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    l.call(e, r) && a(o, r, e[r]);
  if (t)
    for (var r of t(e))
      s.call(e, r) && a(o, r, e[r]);
  return o;
}, c = (o, e) => i(o, p(e));
import h, { forwardRef as n } from "react";
import d from "../lib/IconBase.mjs";
import k from "../defs/SealCheck.mjs";
const w = n((o, e) => /* @__PURE__ */ h.createElement(d, c(m({ ref: e }, o), { weights: k })));
w.displayName = "SealCheck";
export {
  w as SealCheck
};
